<template>
  <el-container class="industry">
    <el-header class="header-style">
      <el-divider content-position="left">客户等级管理</el-divider>
      <el-row style="text-align: right; margin-bottom: 0.4rem">
        <el-col :span="24">
          <el-button type="primary" size="mini" @click="handleAddOpen"
            >新增等级</el-button
          >
        </el-col>
      </el-row>
    </el-header>

    <el-main class="main-style">
      <el-table height="calc(100vh - 276px)" :data="pageData" size="medium" border style="width: 100%">
        <el-table-column label="id">
          <template slot-scope="scope">
            {{ scope.row.level_id }}
          </template>
        </el-table-column>
        <el-table-column label="等级名称">
          <template slot-scope="scope">
            <span class="count_style" style="display: inherit; cursor: pointer">{{
              scope.row.level_name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              size="mini"
              circle
              icon="el-icon-edit-outline"
              type="info"
              @click="handleEdit(scope.$index, scope.row)"
            >
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <!--    页码-->
      <el-pagination
        background
        layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        :total="pageOption.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-footer>

    <!--    添加-->
    <el-drawer
      title="添加"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      size="30%"
    >
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="6" class="m-label">等级名称</el-col>
          <el-col :span="10">
            <el-input
              placeholder="请输入等级名称"
              :size="inputSize"
              v-model="addData.level_name"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">价格（元）</el-col>
          <el-col :span="10">
            <el-input-number
              v-model="addData.level_price"
              :precision="2"
              :step="1"
              :min="0"
            ></el-input-number>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">网页客服通道</el-col>
          <el-col :span="15">
            <el-input
              type="textarea"
              placeholder="请输入网页客服通道链接"
              :size="inputSize"
              v-model="addData.pc_kf_link"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">小程序客服通道</el-col>
          <el-col :span="15">
            <el-input
              type="textarea"
              placeholder="请输入小程序客服通道链接"
              :size="inputSize"
              v-model="addData.we_kf_link"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>
        <div class="addCon">
          <el-button type="primary" size="mini" @click="handleAdd">保存</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 编辑-->
    <el-drawer
      title="编辑"
      :visible.sync="saveDrawer"
      :direction="direction"
      :before-close="handleSaveDrawerClose"
      size="30%"
    >
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="6" class="m-label">等级名称</el-col>
          <el-col :span="10">
            <el-input
              placeholder="请输入等级名称"
              :size="inputSize"
              v-model="saveData.level_name"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">价格（元）</el-col>
          <el-col :span="10">
            <el-input-number
              v-model="saveData.level_price"
              :precision="2"
              :step="1"
              :min="0"
            ></el-input-number>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">网页客服通道</el-col>
          <el-col :span="15">
            <el-input
              type="textarea"
              placeholder="请输入网页客服通道链接"
              :size="inputSize"
              v-model="saveData.pc_kf_link"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">小程序客服通道</el-col>
          <el-col :span="15">
            <el-input
              type="textarea"
              placeholder="请输入小程序客服通道链接"
              :size="inputSize"
              v-model="saveData.we_kf_link"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleSave">保存</el-button>
      </div>
    </el-drawer>
  </el-container>
</template>
<script>
export default {
  name: "ClientLevel",
  data() {
    return {
      option: [],
      inputSize: "small",
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      drawer: false,
      saveDrawer: false,
      direction: "rtl",
      addData: {
        level_name: "",
        level_price: 0,
        pc_kf_link: "",
        we_kf_link: "",
      },
      saveData: {
        level_name: "",
        level_price: 0,
        pc_kf_link: "",
        we_kf_link: "",
        level_id: null,
        index: null,
      },
    };
  },
  computed: {
    pageData: {
      get: function () {
        return this.option.slice(
          this.pageOption.pageSize * (this.pageOption.currentPage - 1),
          this.pageOption.pageSize * this.pageOption.currentPage
        );
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    getData() {
      this.$axios.get("/api/client_level/list").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.option = data.data;
          this.pageOption.total = this.option.length;
        }
      });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getData();
    },
    handleSaveDrawerClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearSaveData();
          done();
        })
        .catch((_) => {});
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.clearAddData();
          done();
        })
        .catch((_) => {});
    },
    handleAddOpen() {
      this.drawer = true;
    },
    handleEdit(index, row) {
      this.saveData.level_name = row.level_name;
      this.saveData.level_price = row.level_price;
      this.saveData.pc_kf_link = row.pc_kf_link;
      this.saveData.we_kf_link = row.we_kf_link;
      this.saveData.level_id = row.level_id;
      this.saveData.index = index;
      this.saveDrawer = true;
    },
    handleDelete(index, id) {
      this.handleDeleteSub(index, id);
    },
    handleDeleteSub(index, id) {
      this.$axios.get("/api/talkcate/delete/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          let idx = this.pageOption.pageSize * (this.pageOption.currentPage - 1) + index;
          this.option.splice(idx, 1);
          this.pageOption.total = this.saveData.length;
          if (index === 0) this.prePage();
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    prePage() {
      if (this.pageOption.currentPage === 1) return;
      this.pageOption.currentPage = this.pageOption.currentPage - 1;
    },
    handleAdd() {
      if (!this.addData.level_name) {
        this.$message.error("等级名称不能为空！");
        return;
      }
      this.$axios
        .post("/api/client_level/create", {
          val: [
            this.addData.level_name,
            this.addData.pc_kf_link,
            this.addData.we_kf_link,
            this.addData.level_price,
          ],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.option.unshift(data.data);
            this.pageOption.total = this.option.length;
            this.$message.success(data.msg);
            this.clearAddData();
            this.drawer = false;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    clearAddData() {
      this.addData.level_name = "";
      this.addData.level_price = 0;
      this.addData.pc_kf_link = "";
      this.addData.we_kf_link = "";
    },
    clearSaveData() {
      this.saveData.level_name = "";
      this.saveData.level_price = 0;
      this.saveData.pc_kf_link = "";
      this.saveData.we_kf_link = "";
    },
    handleSave() {
      if (!this.saveData.level_name) {
        this.$message.error("等级名称不能为空！");
        return;
      }
      this.$axios
        .post("/api/client_level/update/" + this.saveData.level_id, {
          val: [
            this.saveData.level_name,
            this.saveData.pc_kf_link,
            this.saveData.we_kf_link,
            this.saveData.level_price,
          ],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            let index =
              this.pageOption.pageSize * (this.pageOption.currentPage - 1) +
              this.saveData.index;
            this.option[index].level_name = this.saveData.level_name;
            this.option[index].level_price = this.saveData.level_price;
            this.option[index].pc_kf_link = this.saveData.pc_kf_link;
            this.option[index].we_kf_link = this.saveData.we_kf_link;
            this.$message.success(data.msg);
            this.clearSaveData();
            this.saveDrawer = false;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-drawer__wrapper >>> .el-drawer__header span
  color: #4c87fc
  font-size 0.36rem
  font-weight 400
.industry
  marginLeft()
  max-height: 100vh
  .header-style
    height: 100px !important
    padding: 0px !important
  .main-style
    padding: 0px !important
    overflow-y: auto
  .footer-style
    text-align: right
    // background-color: #f5f5f5
    .el-pagination
      padding-top: 25px
.mt-10
  margin-top: .2rem
.tr
  text-align: right
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  overflow-y auto
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
  .el-select
    width: 100%
.industry >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.addCon
  padding: .2rem
  text-align: right
</style>



// WEBPACK FOOTER //
// src/pages/client_level/ClientLevel.vue